import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardDetailsComponent } from './giftcard-details.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { PosPaymentDetailsModule } from 'src/app/shared/pos-payment-details/pos-payment-details/pos-payment-details.module';



@NgModule({
  declarations: [
    GiftcardDetailsComponent
  ],
  imports: [
    CommonModule,
    AccordionModule,
    FormsModule,
    PosPaymentDetailsModule
  ]
})
export class GiftcardDetailsModule { }
